<div>
  <header
    class="title"
    mat-dialog-title
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <i
      nz-icon
      [nzType]="icon"
      nzTheme="outline"
      *ngIf="icon"
      class="search"
    ></i>
    <span>{{ title }}</span>
    <span class="spacer"></span>
    <ng-content select="[header]"></ng-content>
    <button nz-button nzType="text" class="white" (click)="close()">
      <i nz-icon nzType="close"></i>
    </button>
  </header>

  <mat-dialog-content
    class="dialog-content"
    [class.content]="isLargeDialog"
    [style]="contentStyle"
  >
    <ng-content select="[content]"></ng-content>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ng-content select="[actions]"></ng-content>

    <span class="spacer"></span>
    <button nz-button (click)="close()">סגור</button>
  </mat-dialog-actions>
</div>
